// Scroll reveal for page sections that have no built-in Dawn reveal (app sections, custom liquid)
(() => {
  if (window.Shopify?.designMode || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  const init = () => {
    const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section')).filter(
      (section, index) =>
        index > 0 &&
        section.offsetHeight > 0 &&
        !section.querySelector('.scroll-trigger, .cymbru-hero') &&
        section.getBoundingClientRect().top > window.innerHeight
    );
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cymbru-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );

    sections.forEach((section) => {
      section.classList.add('cymbru-reveal');
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
